export const TRAVEL_CREDITS_TITLE = "Travel Credits";
export const TRAVEL_CREDITS_SUBTITLE = "Terms and Conditions";
